<header class="header">
    <div class="header__nav">
        <!-- menu -->
        <div class="header__item header__item--menu">
            <app-sidebar></app-sidebar>
        </div>

        <!-- logo -->
        <a class="header__item header__item--logo" [routerLink]="this.preferredUrl">
            <img src="assets/icons/header/new_logo_next.png" alt="Logo">
        </a>

        <!-- str -->
        <div class="header__item header__item--str-menu">
             @if(strListBool === true){
            <app-str-header-selector></app-str-header-selector>
            }@else {
            <div class="header__str-list">
                <span class="header__str-list-text" [title]="translatedHeader">
                    {{ translatedHeader }}
                </span>
            </div>
            }
        </div>

        <!-- headset -->
        <div class="header__item header__item--headset"
             [class.is-ringing]="voipCallState() === 'ringing'"
             [class.is-active]="voipCallState() === 'connected'">
            <div class="header__headset-wrapper">
                <img class="header__icon header__icon--headset" src="assets/icons/header/headset.svg" alt="Headset">
                @if (voipCallState() === 'ringing') {
                    <span class="header__headset-dot"></span>
                }
            </div>
        </div>

        <!-- alarm -->
        <div class="header__item header__item--alarm" routerLink="/installation-alert">
            <div>
                <img id="alarm-icon" class="header__icon header__icon--alarm" [src]="imgAlert" alt="Alert">
            </div>
        </div>

        <!-- notification -->
        <div class="header__item header__item--notification">
            <app-notifications-menu></app-notifications-menu>
        </div>

        <!-- user -->
        <div class="header__item header__item--user-avatar">
            <app-user-menu></app-user-menu>
        </div>

        <!-- selector-language -->
        <div class="header__item header__item--language">
            <app-language-selector></app-language-selector>
        </div>

        <!-- clock -->
        <div class="header__item header__item--clock">
            <app-clock></app-clock>
        </div>
    </div>
</header>

<app-voip-call></app-voip-call>